import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { COACH_WELCOME_VIDEO_URL } from '../../misc/Constants'

import classes from './WelcomeVideoStep.module.scss'

const WelcomeVideoStep = ({ firstName, done, isSaving, onWatched }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.step}>
      <h3 className={classes.headline}>{t('portal.gettingStarted.welcomeVideo.headline', { name: firstName })}</h3>
      <p className={classes.text}>{t('portal.gettingStarted.welcomeVideo.body')}</p>
      <div className={classNames('embed-responsive embed-responsive-16by9', classes.video)}>
        <iframe
          className='embed-responsive-item'
          src={COACH_WELCOME_VIDEO_URL}
          title={t('portal.gettingStarted.welcomeVideo.videoTitle')}
          allow='autoplay; fullscreen; picture-in-picture'
          allowFullScreen
        />
      </div>
      {!done && (
        <div className={classNames('d-flex justify-content-end', classes.actions)}>
          <button className='btn btn-primary btn-sm' onClick={onWatched} disabled={isSaving}>
            <i className='fa fa-check mr-2' aria-hidden='true' />
            {t('portal.gettingStarted.welcomeVideo.watched')}
          </button>
        </div>
      )}
    </div>
  )
}

WelcomeVideoStep.propTypes = {
  firstName: PropTypes.string,
  done: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onWatched: PropTypes.func.isRequired,
}

export default WelcomeVideoStep
